/**
 * Created by jv on 2020-01-06 (11:40).
 */
const log = require("Sources/utils/logger")();

import utils from "Sources/utils/utils";
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/reconnect.html";

require("Styles/components/views/reconnect.scss");

class ReconnectView extends GameView
{
  constructor(options)
  {
    options.html = $(htmlView);
    super(options);

    this.path = "reconnect";
    this.sessionId = options.sessionId;
  }

  render()
  {
    super.render();
    this._setUpEventListeners();

    this.onRender();
  }

  onRender()
  {
    super.onRender();
  }

  _setUpEventListeners()
  {
    this.$element.find(".cancel-reconnect-btn").off("click").on("click", (e) =>
    {
      if(utils.isFunction(this.onCancelReconnect))
      {
        this.onCancelReconnect.call(this, $(this));
      }
    });
  }

  setReconnectFailed()
  {
    if(this.hasRendered)
    {
      this.$element.find(".reconnect-loader").hide();
      this.$element.find(".reconnect-result").show();
    }
  }

  clearReconnectResult()
  {
    if(this.hasRendered)
    {
      this.$element.find(".reconnect-loader").show();
      this.$element.find(".reconnect-result").hide();
    }
  }
}

module.exports = ReconnectView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/reconnect.js